import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";

import css from "./cell.module.scss";

export const EmptyCell = () => (
  <Stack className={css.cell}>
    <Typography variant="bodyRegular">-</Typography>
  </Stack>
);
